import { ActionTree } from "vuex";
import { RootState } from "../types";
import { ReimbursementsState } from "./types";

export const actions: ActionTree<ReimbursementsState, RootState> = {
  setRefresh({ commit }, newVal) {
    commit("SET_REFRESH", newVal);
  },
};
